module.exports = __webpack_public_path__ + "img/yzm6.7fb9941d.png";